import { Injectable } from '@angular/core';
import {
    DealFormAnswersLittleI,
    FlexiFormFullFormI,
    FlexiFormSectionModel,
    FlexiFormSectionQuestionModel,
    QuestionLittleI,
    QuestionParserI,
} from '@models/models';
import { DatePipe, DecimalPipe } from '@angular/common';
import { digitsInfoCurrency } from '@providers/config/digits.config';

@Injectable()
export class FlexiformHelperService {
    constructor(private datepipe: DatePipe, private decimalpipe: DecimalPipe) {}

    getQuestionResponseBySection(
        flexiform: any,
        fullForm: FlexiFormFullFormI
    ): DealFormAnswersLittleI[] {
        return flexiform.sections
            .map((section: FlexiFormSectionModel) => {
                return {
                    title: section.title,
                    questions: section.questions.map(
                        (question: FlexiFormSectionQuestionModel) => {
                            return {
                                question: question.title,
                                answer:
                                    question.readable_answer ||
                                    question.raw_answer,
                                nameID: question.name_id,
                            };
                        }
                    ),
                };
            })
            .filter(
                (section: FlexiFormSectionModel) => section.questions.length > 0
            );
    }

    questionParser(
        questions: QuestionLittleI[],
        questionsToParse: QuestionParserI[]
    ): QuestionLittleI[] {
        return questions.map((q: QuestionLittleI) => {
            const { question, nameID } = q;
            const questionParser = questionsToParse.find(
                (q) => q.nameID === nameID
            );
            const parsedAnswer = questionParser
                ? this.parseQuestion(q, questionParser)
                : q.answer;
            return {
                question,
                answer: parsedAnswer,
                nameID,
            };
        });
    }

    parseQuestion(question: QuestionLittleI, parser: QuestionParserI): string {
        switch (parser.questionType) {
            case 'date':
                const date = question.answer;
                const isValidDate = this.isValidDate(date);
                question.answer = isValidDate
                    ? this.datepipe.transform(date, 'YYYY/MM/dd')
                    : date;
                break;
            case 'float':
            case 'number':
                const value = question.answer;
                question.answer = this.isValidNumber(value)
                    ? this.decimalpipe.transform(value, digitsInfoCurrency)
                    : value;
                break;
            default:
                break;
        }
        return question.answer;
    }

    isValidDate(dateString: string): boolean {
        const date = new Date(dateString);
        return date instanceof Date && !isNaN(date.getTime());
    }

    isValidNumber(numString: string): boolean {
        const num = Number(numString);
        return !isNaN(num);
    }

    getQuestionTypeByNameID(nameID: string, form: FlexiFormFullFormI): string {
        const sections = form.form.sections || null;
        let questionType = '';
        if (sections) {
            let i = 0;
            while (i < sections.length && questionType === '') {
                const section = sections[i];
                const questions = section.form_template_section.questions || [];
                let j = 0;
                while (j < questions.length && questionType === '') {
                    const question = questions[j].question;
                    if (question.name_id === nameID)
                        questionType = question.format_type;
                    j++;
                }
                i++;
            }
        }
        return questionType;
    }
}
